import { createAction } from 'redux-actions';

export const receiveCommentsForFunction = createAction('comments/RECEIVED_FOR_FUNCTION');
export const receiveRecentComments = createAction('comments/RECEIVED_RECENT');
export const receiveCommentCount = createAction('comments/RECEIVED_COUNT');
export const commentAdded = createAction('comments/ADDED');
export const commentUpdated = createAction('comments/UPDATED');
export const commentRemoved = createAction('comments/REMOVED');
export const markRecentRead = createAction('comments/MARK_RECENT_READ');
export const markFunctionRead = createAction('comments/MARK_FUNCTION_READ');
